import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useContext, useEffect } from 'react';
import PT from 'prop-types';
import { ThemeContext } from 'styled-components';
import { P as PortalContextProvider } from './PortalContext-C2W72KMF.js';
import { a as adoptAncestorZIndex } from './adoptAncestorZIndex-C3h4wKUG.js';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

/**
 * The InlinePortalProvider is used to create a portal to render popover content
 * within a modal-like elements. This allows tab focus work and prevents
 * custom modal z-index from hiding popovers.
 */
const InlinePortalProvider = ({
  children,
  ...rest
}) => {
  var _useContext$portal$in, _useContext;
  const portalRef = useRef(null);
  const zIndexIncrement = (_useContext$portal$in = (_useContext = useContext(ThemeContext)) === null || _useContext === void 0 || (_useContext = _useContext.portal) === null || _useContext === void 0 ? void 0 : _useContext.inlinePortalZIndexIncrement) !== null && _useContext$portal$in !== void 0 ? _useContext$portal$in : 10000;
  useEffect(() => {
    /** Assign a `z-index` value based on the closest ancestor with a non-auto `z-index` and
     * increment it to prevent parent modal-like elements from cutting through. */
    adoptAncestorZIndex(portalRef, zIndexIncrement);
  }, [zIndexIncrement]);
  return /*#__PURE__*/React__default.createElement(PortalContextProvider, {
    portalElementRef: portalRef
  }, children, /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: portalRef
  })));
};
InlinePortalProvider.propTypes = {
  /**
   * The children to render into the `Portal`.
   */
  children: PT.node
};
InlinePortalProvider.defaultProps = {
  children: null
};

export { InlinePortalProvider as I };
//# sourceMappingURL=InlinePortalProvider-CZof7mQs.js.map
